<ng-container *ngIf="formControl">
  <div
    class="input-container"
    [@incrementDecrement]="flashClass"
    [@.disabled]="!flashOnChange"
  >
    <div
      class="input-container__spinner-container"
      *ngIf="(showSpinner || formControl.status === 'PENDING') && widthOfInput"
      [ngStyle]="{ 'width.px': widthOfInput }"
    >
      <span class="spinner spinner-sm spinner-inverse"> </span>
    </div>
    <ng-container *ngIf="!useBasicTextBox; else useBasicTextbox">
      <clr-input-container>
        <input
          clrInput
          [inputValidator]="inputValidatorKey"
          [fieldName]="formControlName"
          [required]="required"
          [id]="id"
          [formControl]="formControl"
          [readOnly]="formControl.status === 'PENDING' || readOnly"
          [type]="type"
          [placeholder]="placeholder"
          [tabIndex]="tabIndex"
          [title]="title"
          spellcheck="false"
          autocomplete="off"
          (input)="onInput($event)"
          [ngStyle]="{
            color: textColor
          }"
          (blur)="onElemBlur()"
          (focus)="onElemFocus()"
          #inputElem
        />
      </clr-input-container>
    </ng-container>

    <ng-template #useBasicTextbox>
      <input
        class="clr-input basic-text-box"
        [inputValidator]="inputValidatorKey"
        [fieldName]="formControlName"
        [required]="required"
        [id]="id"
        [formControl]="formControl"
        [readOnly]="formControl.status === 'PENDING' || readOnly"
        [type]="type"
        [placeholder]="placeholder"
        [tabIndex]="tabIndex"
        [title]="title"
        (input)="onInput($event)"
        spellcheck="false"
        autocomplete="off"
        [ngStyle]="{
          color: textColor
        }"
        (blur)="onElemBlur()"
        (focus)="onElemFocus()"
        #inputElem
      />
    </ng-template>
    <div class="input-container__info" *ngIf="info">
      {{ info }}
    </div>
  </div>
</ng-container>
